export default __webpack_public_path__ + "static/media/TreasureHunting_07.510fc473.png";